/**
 * Environment-gated logging utility.
 * - Only emits output when NODE_ENV !== "production".
 * - In production builds these become effectively no-ops, so no debug info
 *   leaks to end users and there's no perf hit in hot paths.
 *
 * Usage:
 *   import { devWarn, devLog } from "@/lib/devLog";
 *   devWarn("[radar] gps failed:", err);
 */

const isDev = typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production";

export function devLog(...args) {
  if (isDev && typeof console !== "undefined") console.log(...args);
}

export function devWarn(...args) {
  if (isDev && typeof console !== "undefined") console.warn(...args);
}

export function devError(...args) {
  // Errors we keep even in prod — they typically bubble to Sentry / DevTools
  // Comment out this branch if you want fully silent prod builds.
  if (typeof console !== "undefined") console.error(...args);
}
